import React, { useState } from "react";
import QRCode from "qrcode.react";

import CopyToClipboard from "react-copy-to-clipboard";
import "./Pagamento.css";

const Payment = ({ onPrev, qrCode, orderId, orderList }) => {
  // Generate a fictitious payment data

  const [copied, setCopied] = useState(false);
  const paymentData = "something";

  if (qrCode && qrCode === "FAKE_QR_CODE_12345") {
    return (
      <div className="pagamento-container">
        <h2>Erro ao gerar o QR Code</h2>
        <p>Por favor, verifique se o CPF informado é válido, acessando o seu <a className="link-simples" target="_blank"
          rel="noopener noreferrer" href="https://insigneacademica.com.br/editora-insigne/perfil">perfil.</a></p>
        <p>Se o problema persistir, por favor, entre em contato conosco pelo WhatsApp.</p>
        <a
          href="https://api.whatsapp.com/send?phone=5584992293892&text=Olá! Gostaria de falar com o suporte da Editora Insigne Acadêmica sobre um erro ao gerar o QR Code de pagamento."
          target="_blank"
          rel="noopener noreferrer"
          className="main-btn"
        >
          Contatar pelo WhatsApp
        </a>
      </div>
    );
  }

  return (
    <div className="pagamento-container">
      {!orderList && <h2>Seu pedido foi gerado com sucesso!</h2>}

      <h3 className="pagamento-copy">Pague com pix:</h3>

      <div>
        <li>Abra o aplicativo do seu banco ou instituição financeira.</li>
        <li>Selecione a opção de pagamento Pix.</li>
        <li>Escaneie o QR Code abaixo ou copie o código.</li>
        <li>Cole o código no campo de pagamento.</li>
        <li>Confirme o pagamento.</li>
      </div>

      {/* Display the QR code */}
      <div className="qrcode-container">
        <QRCode value={qrCode ? qrCode : paymentData} size={200} />
      </div>
      <div className="copy-code-container">
        <p>Código Pix:</p>
        <input type="text" value={qrCode ? qrCode : paymentData} readOnly />
        {copied && <div>Copiado!</div>}
      </div>

      <CopyToClipboard
        text={qrCode ? qrCode : paymentData}
        onCopy={() => setCopied(true)}
      >
        <button>Copiar código</button>
      </CopyToClipboard>

      {!orderList && (
        <h3>
          Acompanhe detalhes do pedido e status de pagamento através do seu
          perfil!
        </h3>
      )}
      {!orderList && (
        <h3>
          Após a confirmação do pagamento os livros estarão disponíveis para
          download na sua página de perfil, em 'Meus Livros'!
        </h3>
      )}
    </div>
  );
};

export default Payment;